var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2346_14266)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "black",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9906 20.0007L28.1244 12.8669C28.3972 12.5932 28.3975 12.1505 28.1244 11.8771C27.8499 11.6035 27.4075 11.6035 27.1341 11.8771L20.0007 19.0106L12.8669 11.8771C12.5947 11.6035 12.1505 11.6035 11.8771 11.8771C11.6035 12.1502 11.6035 12.5932 11.8771 12.8669L19.0106 20.0007L11.8777 27.1335C11.6041 27.4072 11.6041 27.8499 11.8777 28.1238C12.0146 28.26 12.1934 28.329 12.3726 28.3287C12.5521 28.329 12.7309 28.26 12.8675 28.1238L20.0006 20.9906L27.1341 28.1241C27.2709 28.2603 27.4504 28.3294 27.6293 28.3294C27.8078 28.3294 27.9873 28.2603 28.1244 28.1241C28.3975 27.8502 28.3975 27.4071 28.1241 27.1338L20.9906 20.0007Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0007 0.207031C9.08775 0.207031 0.208984 9.08579 0.208984 19.9987C0.208984 30.9116 9.08775 39.7904 20.0007 39.7904C30.9136 39.7904 39.7923 30.9116 39.7923 19.9987C39.7923 9.08579 30.9136 0.207031 20.0007 0.207031ZM20.0007 38.39C9.85978 38.39 1.60932 30.1396 1.60932 19.9987C1.60932 9.85704 9.85899 1.60659 20.0007 1.60659C30.1423 1.60659 38.392 9.85704 38.392 19.9987C38.392 30.1396 30.1423 38.3892 20.0007 38.3892V38.39Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2346_14266"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.bca9cb7c5d076fbfb874c27918ea7bbe.svg";
export { ForwardRef as ReactComponent };